import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { images, masterMapSteps } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { CtaButton } from "../ui/CtaButton";
export function MasterMapSection() {
  return <section className="bg-navydeep px-5 py-16 sm:py-24" data-id="element-171" data-mp="1a8lles5gebt0">
      <div className="mx-auto max-w-4xl" data-id="element-172" data-mp="15er2hqxoa0uz">
        <SectionHeading tone="dark" eyebrow="The Framework" title="The Endo Blueprint™ Master Map" data-id="element-173" data-mp="15dxtejb8qz9o" />

        <ol className="mx-auto mt-10 max-w-xl" data-id="element-174" data-mp="1j909u0dps70q">
          {masterMapSteps.map((step, i) => <li key={step.title} className="flex flex-col items-center" data-id="element-175" data-mp="1eagkdpzwwd3m" data-mpi={i}>
              <div className="flex w-full items-center gap-4 rounded-2xl border border-white/10 bg-navy p-4 sm:p-5" data-id="element-176" data-mp="1t4uxj9wsosad">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cyan font-display text-xl font-bold text-navydeep" data-id="element-177" data-mp="1o474yjsx43e1">
                  {i + 1}
                </span>
                <div className="text-left" data-id="element-178" data-mp="3pzpu6p484jpc">
                  <p className="text-[17px] font-extrabold uppercase tracking-wide text-white" data-id="element-179" data-mp="t0n7lztsvjwv">{step.title}</p>
                  <p className="mt-0.5 text-sm text-white/70" data-id="element-180" data-mp="x2h3lut1vzqp">{step.text}</p>
                </div>
              </div>
              {i < masterMapSteps.length - 1 && <ArrowDownIcon className="my-2 h-6 w-6 text-cyan" aria-hidden="true" data-id="element-181" data-mp="16qz225duxur6" />}
            </li>)}
        </ol>

        <p className="mx-auto mt-8 max-w-xl text-center text-sm italic leading-relaxed text-white/65" data-id="element-182" data-mp="1bptsnti2gnlu">
          A visual framework for organizing your thinking—not a substitute for clinical judgment, professional training,
          or patient-specific evaluation.
        </p>

        <div className="mt-16 border-t border-white/10 pt-14" data-id="element-183" data-mp="1pp1uyv9j0bu9">
          <SectionHeading tone="dark" title="The 6 Volumes and 5 Bonuses of the Endo Blueprint™" subtitle="One integrated visual reference system to help you connect the major areas of endodontics." data-id="element-184" data-mp="3mieje15d63v3" />
          <div className="-mx-5 mt-6 sm:mx-auto sm:max-w-3xl" data-id="element-185" data-mp="ynsjcyd328hv">
            <img src={images.hero} alt="The complete Endo Blueprint collection" className="w-full" data-id="element-186" data-mp="to69mywgradt" />
          </div>
          <div className="mt-6" data-id="element-187" data-mp="17nxqr8ia16w1">
            <CtaButton label="View the Complete Endo Blueprint™ Collection" size="md" data-id="element-188" data-mp="17oz3riius3ge" />
          </div>
        </div>
      </div>
    </section>;
}